<template>
  <div class="links" :class="{ row }">
    <DesktopOnly css>
      <NavBarVisaCountrySelect />
    </DesktopOnly>
    <AppLink plain to="/status">{{ $tt('nav.visa_status') }}</AppLink>
    <AppLink plain to="/about">{{ $tt('page.about') }}</AppLink>
    <AppLink plain to="/blog" v-if="$branch.blog">{{ $tt('nav.blog') }}</AppLink>
    <DesktopOnly css>
      <NavBarContactLinksSelect />
    </DesktopOnly>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  row?: boolean;
}>();
</script>

<style scoped>
.links {
  display: flex;
  gap: var(--space-4);
  flex-direction: column;
  align-items: flex-start;
}
.links.row {
  gap: var(--space-6);
  flex-direction: row;
}

@media (min-width: 851px) and (max-width: 1100px) {
  .links.row {
    gap: var(--space-3);
  }
}
</style>